import { useState } from 'react';
import { unitService } from 'services/api';
import AvisoModal from 'components/AvisoModal';
import SearchableSelect from 'components/SearchableSelect';
import styles from './UnitFormModal.module.css';

// 'residencial' ya no se ofrece para unidades nuevas (se reemplazó por
// apartamento/casa), pero se conserva en TIPO_ICON para mostrar unidades
// antiguas que todavía tengan ese valor.
const TIPOS = ['apartamento', 'casa', 'local', 'bodega', 'oficina', 'parqueadero'];
// Exportado porque la lista de Units.jsx también lo usa para el ícono de cada fila.
export const TIPO_ICON = { residencial: '🏠', apartamento: '🏢', casa: '🏡', local: '🏪', bodega: '📦', oficina: '💼', parqueadero: '🚗' };

// Mismo tope que valida el backend (unitsController.js).
const MAX_NUMERO_UNIDAD = 20;

// Con noValidate el navegador ya no bloquea el envío por su cuenta — se
// revisa acá lo mismo que antes garantizaban los `required` nativos, con el
// mismo mensaje en el alert-danger que ya usa el resto de la app.
function validarCampos(form) {
  if (!String(form.numero_unidad).trim()) return 'El número de unidad es requerido';
  if (String(form.numero_unidad).trim().length > MAX_NUMERO_UNIDAD) {
    return `El número de unidad no puede tener más de ${MAX_NUMERO_UNIDAD} caracteres`;
  }
  if (!form.building_id) return 'La torre es requerida';
  if (form.coefficiente_votacion !== '' && form.coefficiente_votacion !== null && form.coefficiente_votacion !== undefined) {
    const coef = parseFloat(form.coefficiente_votacion);
    if (isNaN(coef) || coef < 0 || coef > 1) {
      return 'El coeficiente de votación debe ser un número entre 0 y 1 (ej. 0.05 = 5%)';
    }
  }
  return null;
}

export default function UnitFormModal({ editing, buildings, defaultBuildingId, onClose, onSaved }) {
  const [form, setForm] = useState({
    numero_unidad:        editing?.numero_unidad || '',
    building_id:          editing?.building_id || defaultBuildingId || '',
    tipo_inmueble:        editing?.tipo_inmueble || 'apartamento',
    coefficiente_votacion: editing?.coefficiente_votacion ?? '',
  });
  const [modalError, setModalError] = useState('');

  const save = async (e) => {
    e.preventDefault();
    setModalError('');
    const campoError = validarCampos(form);
    if (campoError) return setModalError(campoError);
    try {
      if (editing) await unitService.update(editing.id, form);
      else         await unitService.create(form);
      onSaved(editing ? 'Unidad actualizada' : 'Unidad creada');
    } catch (err) {
      // El error se muestra DENTRO del modal (antes iba a un `alert` de toda
      // la página, que queda tapado detrás del modal abierto — el admin
      // nunca lo veía hasta cerrar el modal a ciegas).
      setModalError(err.response?.data?.message || 'Error al guardar');
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header"><h3>{editing ? 'Editar' : 'Nueva'} unidad</h3><button className="btn-close" onClick={onClose}>✕</button></div>
        <form onSubmit={save} noValidate>
          <div className="modal-body">
            {modalError && (
              <AvisoModal>
                <i className={`fas fa-exclamation-circle ${styles.iconoError}`} />
                {modalError}
              </AvisoModal>
            )}
            <div className="form-group"><label className="form-label">Número de unidad *</label><input type="number" min="1" step="1" className="form-control" placeholder="Ej: 101" value={form.numero_unidad} onChange={e => setForm(f => ({ ...f, numero_unidad: e.target.value }))} required /></div>
            <div className="form-group"><label className="form-label">Torre *</label><SearchableSelect value={form.building_id} onChange={(id) => setForm(f => ({ ...f, building_id: id }))} placeholder="Seleccione..." allowEmpty={false} minWidth={0} maxWidth={9999} ariaLabel="Torre"
              options={buildings.map(b => ({ value: b.id, label: b.numero_torre }))} /></div>
            <div className="form-group"><label className="form-label">Tipo de inmueble</label><SearchableSelect value={form.tipo_inmueble} onChange={(v) => setForm(f => ({ ...f, tipo_inmueble: v }))} minWidth={0} maxWidth={9999} allowEmpty={false} ariaLabel="Tipo de inmueble" options={TIPOS.map(t => ({ value: t, label: `${TIPO_ICON[t]} ${t}` }))} /></div>
            <div className="form-group"><label className="form-label">Coeficiente de votación</label><input type="number" step="0.0001" min="0" max="1" className="form-control" value={form.coefficiente_votacion} onChange={e => setForm(f => ({ ...f, coefficiente_votacion: e.target.value }))} />
              <div className={styles.notaTorre}>
                Por la Ley 675 de 2001 (arts. 25 a 27) el coeficiente es de cada unidad privada: sale del área privada construida de la unidad sobre el área privada total del conjunto. Escríbelo como fracción entre 0 y 1 (0.0049 equivale a 0,49 %).
              </div></div>
          </div>
          <div className="modal-footer"><button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button><button type="submit" className="btn btn-primary"><i className="fas fa-save" /> Guardar</button></div>
        </form>
      </div>
    </div>
  );
}
